import { GuardianSelector, WizardFooter, WizardTitle } from "@components"
import { Chip } from "@heroui/react"
import { AdjustmentsHorizontalIcon } from "@heroicons/react/24/outline"
import { PropTypes } from "prop-types"

const Step2 = ({ 
  handleClearAll,
  handleLoadMore,
  handlePrevious, 
  handleNext, 
  handleSearchChange, 
  handleSearchClear,
  handleSelectAll,
  handleToggleSelected, 
  invitations, 
  invitationSelections,
  isSubmitting,
  searchTerm = "",
}) => {  

  const selectedInvitationIds = invitationSelections.filter(invitation => invitation.selected)
  const unselectedInvitationIds = invitationSelections.filter(invitation => !invitation.selected)

  return (
    <div>      
      <WizardTitle 
        title="Step 2 of 3 - Filter Guardians" 
        description="Deselect any guardians you wish to ignore." 
        icon={<AdjustmentsHorizontalIcon />}
        titleAddon={
          <Chip className={`font-semibold text-white ${selectedInvitationIds.length > 0 ? 'bg-green-500' : 'bg-orange-500'}`}>
            {selectedInvitationIds.length} of {invitationSelections.length} Selected
          </Chip>
        }
      />

      <GuardianSelector
        handleClearAll={handleClearAll}
        handleLoadMore={handleLoadMore}
        handleSearchChange={handleSearchChange}
        handleSearchClear={handleSearchClear}
        handleSelectAll={handleSelectAll}
        handleToggleSelected={handleToggleSelected}
        invitations={invitations}
        searchTerm={searchTerm}
        selectedInvitationIds={selectedInvitationIds.map(invitationIds => invitationIds.invitation_id)}
        noOfSelected={selectedInvitationIds.length}
        noOfDeselected={unselectedInvitationIds.length}
      />

      <WizardFooter 
        currentStep={2} 
        totalSteps={3} 
        previousCaption="Choose Recipients" 
        nextCaption="Confirm & Send" 
        handlePrevious={() => handlePrevious()} 
        handleNext={() => handleNext()}
        isNextButtonDisabled={selectedInvitationIds.length === 0}
        isSubmitting={isSubmitting}
      />
    </div>
  )
}

Step2.propTypes = {
  handleClearAll: PropTypes.func.isRequired,
  handleLoadMore: PropTypes.func.isRequired,
  handlePrevious: PropTypes.func.isRequired,
  handleNext: PropTypes.func.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  handleSearchClear: PropTypes.func.isRequired,
  handleSelectAll: PropTypes.func.isRequired,
  handleToggleSelected: PropTypes.func.isRequired,
  invitations: PropTypes.array.isRequired,
  invitationSelections: PropTypes.array.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  searchTerm: PropTypes.string,
}

export default Step2
